import { render, staticRenderFns } from "./CreateTenantProject.vue?vue&type=template&id=4ffde974&"
import script from "./CreateTenantProject.vue?vue&type=script&lang=js&"
export * from "./CreateTenantProject.vue?vue&type=script&lang=js&"
import style0 from "./CreateTenantProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ffde974')) {
      api.createRecord('4ffde974', component.options)
    } else {
      api.reload('4ffde974', component.options)
    }
    module.hot.accept("./CreateTenantProject.vue?vue&type=template&id=4ffde974&", function () {
      api.rerender('4ffde974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/information/CreateTenantProject.vue"
export default component.exports